import { Card, CardContent, CardHeader } from '../card'
import { TrendingUp } from 'lucide-react'
import { GlowingEffect } from '../glowing-effect'
import { Switch } from '../switch'
import { Label } from '../label'
import { AnimatedToolsDemo } from './animated-tools-demo'

export function Features() {
    return (
        <section className="py-20 bg-background">
            <div className="mx-auto max-w-7xl px-6">
                {/* Features Title */}
                <div className="text-center mb-16">
                    <span className="inline-block px-3 py-1 mb-4 text-sm rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-black text-black dark:text-white">
                        ⚡ Features
                    </span>
                    <h2 className="text-4xl lg:text-6xl font-bold tracking-tight text-foreground mb-4">
                        Powerful Features
                    </h2>
                    <p className="mt-4 text-lg text-gray-500 dark:text-white max-w-xl mx-auto">
                        Everything you need to build and deploy intelligent AI agents that work seamlessly with your business.
                    </p>
                </div>
                
                <div className="mx-auto grid gap-2 sm:grid-cols-5">
                    <div className="sm:col-span-3">
                        <Card className="group shadow-black/5 rounded-xl h-[400px] flex flex-col relative">
                            <GlowingEffect
                                spread={40}
                                glow={true}
                                disabled={false}
                                proximity={64}
                                inactiveZone={0.01}
                                borderWidth={2}
                            />
                            <div className="relative h-fit flex-1 overflow-hidden">
                                <div className="absolute -inset-6 [background:radial-gradient(75%_95%_at_50%_0%,transparent,hsl(var(--background))_100%)]"></div>

                                <div className="bg-background overflow-hidden rounded-xl border-l border-t pl-2 pt-2 dark:bg-zinc-950 h-full mx-2 mt-2">
                                    <div className="flex justify-center items-center h-full py-3 px-4">
                                        <img
                                            src="/images/llms.png"
                                            alt="LLMs Interface"
                                            className="w-full h-auto max-w-sm rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <CardHeader className="p-6">
                                <p className="font-medium">Choose the best AI model</p>
                                <p className="text-muted-foreground mt-3 max-w-sm text-sm">Integrate with top LLM's and tune for the right balance of speed and accuracy</p>
                            </CardHeader>
                        </Card>
                    </div>

                    <div className="sm:col-span-2">
                        <Card className="group shadow-black/5 rounded-xl h-[400px] flex flex-col relative">
                            <GlowingEffect
                                spread={40}
                                glow={true}
                                disabled={false}
                                proximity={64}
                                inactiveZone={0.01}
                                borderWidth={2}
                            />
                            <div className="relative h-fit flex-1">
                                <div className="absolute -inset-6 [background:radial-gradient(75%_95%_at_50%_0%,transparent,hsl(var(--background))_100%)]"></div>

                                <div className="bg-background overflow-hidden rounded-xl border-l border-t pl-2 pt-2 dark:bg-zinc-950 mx-2 mt-2 h-full">
                                    <div className="flex flex-col justify-center items-center space-y-6 py-3 px-4 h-full">
                                        {/* End Call Card */}
                                        <div className="bg-card border rounded-lg p-4 w-full max-w-sm shadow-sm">
                                            <div className="flex items-center justify-between space-x-3">
                                                <Label 
                                                    htmlFor="end-call-switch" 
                                                    className="text-sm font-medium cursor-not-allowed opacity-75"
                                                >
                                                    End Call
                                                </Label>
                                                <Switch 
                                                    id="end-call-switch"
                                                    checked={true}
                                                    disabled
                                                    className="opacity-100"
                                                />
                                            </div>
                                        </div>
                                        
                                        {/* Detect Language Card */}
                                        <div 
                                            className="bg-card border rounded-lg p-4 w-full max-w-sm shadow-sm cursor-default"
                                            style={{
                                                maskImage: 'linear-gradient(to bottom, black 0%, black 70%, transparent 100%)',
                                                WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 70%, transparent 100%)'
                                            }}
                                        >
                                            <div className="flex items-center justify-between space-x-3">
                                                <Label 
                                                    htmlFor="detect-language-switch" 
                                                    className="text-sm font-medium cursor-not-allowed opacity-75"
                                                >
                                                    Detect Language
                                                </Label>
                                                <Switch 
                                                    id="detect-language-switch"
                                                    checked={true}
                                                    disabled
                                                    className="opacity-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <CardHeader className="p-6">
                                <p className="font-medium">Automate actions</p>
                                <p className="text-muted-foreground mt-3 max-w-sm text-sm">Automate AI Agents actions with ease for realstice customer experience</p>
                            </CardHeader>
                        </Card>
                    </div>
                    <div className="sm:col-span-2">
                        <Card className="group shadow-black/5 rounded-xl flex flex-col relative">
                            <GlowingEffect
                                spread={40}
                                glow={true}
                                disabled={false}
                                proximity={64}
                                inactiveZone={0.01}
                                borderWidth={2}
                            />
                            <div className="relative h-fit overflow-hidden">
                                <div className="absolute -inset-6 [background:radial-gradient(75%_95%_at_50%_0%,transparent,hsl(var(--background))_100%)]"></div>
                                
                                <div className="bg-background overflow-hidden rounded-xl border-l border-t pl-2 pt-2 dark:bg-zinc-950 mx-2 mt-2">
                                    <div className="py-3 px-4">
                                        {/* KPI Card */}
                                        <div className="bg-card rounded-lg p-4">
                                            <div className="flex justify-between items-start mb-3">
                                                <h4 className="text-muted-foreground text-sm font-medium">Total Calls</h4>
                                                <div className="flex items-center gap-1 text-green-600 text-sm font-medium">
                                                    <TrendingUp className="size-3" />
                                                    <span>+12.5%</span>
                                                </div>
                                            </div>
                                            <div className="mb-2">
                                                <div className="text-2xl font-bold">8,560</div>
                                            </div>
                                            
                                            {/* Active Calls Badge */}
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                                <span className="text-muted-foreground text-xs">Active calls</span>
                                                <span className="text-sm font-semibold">344</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <CardHeader className="p-6">
                                <p className="font-medium">Dashboard Analytics</p>
                                <p className="text-muted-foreground mt-3 max-w-sm text-sm">Monitor performance with simple charts and numbers. See how many customers it helped, problems it solved, and money it saved your business.</p>
                            </CardHeader>
                        </Card>
                    </div>
                    <div className="sm:col-span-3">
                        <Card className="group shadow-black/5 rounded-xl flex flex-col relative">
                            <GlowingEffect
                                spread={40}
                                glow={true}
                                disabled={false}
                                proximity={64}
                                inactiveZone={0.01}
                                borderWidth={2}
                            />
                            <CardContent className="relative h-fit py-3">
                                <div className="grid grid-cols-4 gap-1 md:grid-cols-6">
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/arabic.jpeg"
                                            alt="Arabic flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/english.jpeg"
                                            alt="English flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/china.jpeg"
                                            alt="China flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/spain.jpeg"
                                            alt="Spain flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/france.jpeg"
                                            alt="France flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                    <div className="rounded-(--radius) bg-muted/50 flex aspect-square items-center justify-center border p-2">
                                        <img
                                            className="m-auto size-6 rounded-sm"
                                            src="/images/flags/urdu.jpeg"
                                            alt="Urdu flag"
                                            width="24"
                                            height="24"
                                        />
                                    </div>
                                </div>
                            </CardContent>
                            <CardHeader className="p-6">
                                <p className="font-medium">Speaks Your Customer's Language</p>
                                <p className="text-muted-foreground mt-3 max-w-sm text-sm">Talk to customers in their own language automatically. No need to worry about language barriers anymore.</p>
                            </CardHeader>
                        </Card>
                    </div>
                </div>
                
                {/* AnimatedBeam Integration Section */}
                <div className="mt-20">
                    <div className="text-center mb-12">
                        <span className="inline-block px-3 py-1 mb-4 text-sm rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-black text-black dark:text-white">
                            🔗 Seamless Integrations
                        </span>
                        <h2 className="text-4xl lg:text-6xl font-bold tracking-tight text-foreground mb-4">
                            Connect Everything
                        </h2>
                        <p className="mt-4 text-lg text-gray-500 dark:text-white max-w-xl mx-auto">
                            Connect with your favorite tools and platforms. Our AI agents work seamlessly across all your existing workflows.
                        </p>
                    </div>
                    
                    <Card className="group shadow-black/5 rounded-xl relative overflow-hidden">
                        <GlowingEffect
                            spread={40}
                            glow={true}
                            disabled={false}
                            proximity={64}
                            inactiveZone={0.01}
                            borderWidth={2}
                        />
                        <CardContent className="p-8">
                            <AnimatedToolsDemo />
                        </CardContent>
                        <CardHeader className="p-6">
                            <p className="font-medium text-left">Connect Everything</p>
                            <p className="text-muted-foreground mt-3 text-left text-sm">
                                Integrate with 1000+ apps and services. Your AI agents can access and work with all your favorite tools automatically.
                            </p>
                        </CardHeader>
                    </Card>
                </div>
            </div>
        </section>
    )
}
